import { css } from '@emotion/core'
import PropTypes from 'prop-types'
import React from 'react'

const Page = ({ backgroundColor, color, children }) => (
  <section
    title="Page"
    css={css`
      margin: 2rem auto;
      width: 700px;
      font-size: 1.18rem;
      line-height: 1.44;
      @media (max-width: 720px) {
        width: auto;
        margin: 2rem 5%;
      }
    `}
  >
    {children}
  </section>
)

Page.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
}

Page.defaultProps = {
  backgroundColor: 'black',
  color: 'white',
}

export default Page
